import { createContext } from "react";

export const ProductoContext = createContext()